document.addEventListener("DOMContentLoaded", function () {
  var carousels = document.querySelectorAll(".owl-carousel");

  carousels.forEach(function (carousel) {
    $(carousel).owlCarousel({
      loop: false,       // ✅ disables cloning
      margin: 10,
      nav: true,
      dots: true,
      items: 1
    });
  });
});
